export default __webpack_public_path__ + "static/media/copy_white.375f765c.svg";